<div class="flex h-full flex-col px-3 py-2">
  <div class="shrink-0 mb-2">
    <h2 class="text-sm font-semibold text-slate-700">Cobranza en el tiempo</h2>
    <p class="text-base font-bold text-slate-900 mt-0.5 tabular-nums">
      {{ formatCurrency(data()?.collection?.amount ?? 0) }}
    </p>
    <p class="text-xs text-slate-400">Cobros registrados por día (facturas pagadas)</p>
  </div>
  @if ((data()?.heatMapData?.length ?? 0) === 0) {
    <div class="flex-1 flex items-center justify-center text-slate-400 text-sm">
      Sin datos recientes
    </div>
  } @else {
    <div class="flex-1 min-h-0">
      <p-chart class="block h-full w-full" type="bar" [data]="chartData()" [options]="chartOptions" />
    </div>
  }
</div>
